import GuestEditPageContainer from './containers/GuestEditPageContainer'

export default GuestEditPageContainer
